module.exports = __webpack_public_path__ + "img/2025special_07.34ae1a7f.jpg";